const RadiantDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M85.6,16.98c0-0.05-0.02-0.1-0.03-0.14c-0.01-0.03-0.01-0.06-0.02-0.09c0-0.01,0-0.01,0-0.02
	c-0.02-0.04-0.05-0.07-0.08-0.1c-0.02-0.02-0.03-0.05-0.05-0.07l-13-12c-0.02-0.02-0.05-0.03-0.08-0.05
	c-0.02-0.01-0.04-0.03-0.06-0.05c-0.01,0-0.02,0-0.03-0.01c-0.04-0.02-0.09-0.03-0.13-0.04c-0.03-0.01-0.06-0.02-0.09-0.02
	c-0.01,0-0.01,0-0.02,0H28c-0.01,0-0.01,0-0.02,0c-0.03,0-0.06,0.01-0.09,0.02c-0.04,0.01-0.09,0.02-0.13,0.03
	c-0.01,0-0.02,0-0.03,0.01c-0.02,0.01-0.04,0.03-0.06,0.05c-0.03,0.02-0.06,0.03-0.08,0.05l-13,12c-0.02,0.02-0.03,0.05-0.05,0.07
	c-0.03,0.03-0.06,0.06-0.08,0.1c0,0.01,0,0.01,0,0.02c-0.01,0.03-0.02,0.06-0.02,0.09c-0.01,0.05-0.03,0.09-0.03,0.14
	c0,0.01,0,0.01,0,0.02v66c0,0.01,0,0.01,0,0.02c0,0.05,0.02,0.09,0.03,0.14c0.01,0.03,0.01,0.06,0.02,0.09c0,0.01,0,0.01,0,0.02
	c0.01,0.01,0.02,0.02,0.03,0.03c0.03,0.05,0.06,0.1,0.1,0.14l13,12c0.02,0.02,0.05,0.03,0.08,0.05c0.02,0.01,0.04,0.03,0.06,0.05
	c0.01,0,0.02,0,0.02,0.01c0.08,0.03,0.16,0.06,0.24,0.06h44c0.09,0,0.17-0.02,0.24-0.06c0.01,0,0.02,0,0.02-0.01
	c0.02-0.01,0.04-0.03,0.06-0.05c0.03-0.02,0.06-0.03,0.08-0.05l13-12c0.04-0.04,0.07-0.09,0.1-0.14c0.01-0.01,0.02-0.02,0.03-0.03
	c0-0.01,0-0.01,0-0.02c0.01-0.03,0.02-0.06,0.02-0.09c0.01-0.05,0.03-0.09,0.03-0.14c0-0.01,0-0.01,0-0.02V17
	C85.6,16.99,85.6,16.99,85.6,16.98z M72.18,94.02l-2.44-4.88l9.36-8.42l4.86,2.43L72.18,94.02z M28.97,94.4l2.4-4.8h37.26l2.4,4.8
	H28.97z M16.04,83.15l4.86-2.43l9.36,8.42l-2.44,4.88L16.04,83.15z M15.6,17.97l4.8,2.4v59.26l-4.8,2.4V17.97z M27.82,5.98
	l2.44,4.88l-9.36,8.42l-4.86-2.43L27.82,5.98z M71.03,5.6l-2.4,4.8H31.37l-2.4-4.8H71.03z M83.96,16.85l-4.86,2.43l-9.36-8.42
	l2.44-4.88L83.96,16.85z M34.36,88.4L50,82.64l15.64,5.76H34.36z M65.64,11.6L50,17.36L34.36,11.6H65.64z M50,81.4l-18.42-1.94
	L30.6,50l0.98-29.46L50,18.6l18.42,1.94L69.4,50l-0.98,29.46L50,81.4z M68.4,19.33l-15.78-1.66l15.78-5.81V19.33z M31.6,19.33v-7.47
	l15.78,5.81L31.6,19.33z M29.52,46.32L21.81,20.6h8.57L29.52,46.32z M30.38,79.4h-8.57l7.72-25.72L30.38,79.4z M31.6,80.67
	l15.78,1.66L31.6,88.14V80.67z M68.4,80.67v7.47l-15.78-5.81L68.4,80.67z M70.48,53.68l7.72,25.72h-8.57L70.48,53.68z M69.62,20.6
	h8.57l-7.72,25.72L69.62,20.6z M69.6,19.4v-7.05l7.84,7.05H69.6z M30.4,19.4h-7.84l7.84-7.05V19.4z M21.6,24.09L29.37,50L21.6,75.91
	V24.09z M30.4,80.6v7.05l-7.84-7.05H30.4z M69.6,80.6h7.84l-7.84,7.05V80.6z M78.4,75.91L70.63,50l7.77-25.91V75.91z M79.6,79.63
	V20.37l4.8-2.4v64.06L79.6,79.63z"
      />
    </svg>
  )
}

export default RadiantDiamond
